// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarMovimentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/financeiro-movimento/migrar-todas
 * (controllers/migration/laudos.php::migrar_todas).
 *
 * O fechamento da carga de laudos de UMA franquia: o run, a contabilidade dos
 * quatro desfechos por lista (`por_tipo`), os dois contadores da varredura
 * GLOBAL de fotos (alheias e sem pai — silenciosas por desenho, ver
 * LaudoMigrationService), e o desfecho de cada linha.
 *
 * `migradas + skipped + bloqueadas + falhas == total`, sempre.
 */
import type { Migration_MovimentoResultadoRow } from './Migration_MovimentoResultadoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_MigrarMovimentoResponseDados {
run_id: number
total: number
migradas: number
skipped: number
bloqueadas: number
falhas: number
por_tipo: Record<string, Record<string, number>>
erros_zoho: string[]
resultados: Migration_MovimentoResultadoRow[]
}

export type Migration_MigrarMovimentoResponse = ApiResponse<Migration_MigrarMovimentoResponseDados>;

registerResponseContract('Migration_MigrarMovimentoResponse', {
  run_id:     { type: 'number',  required: true },
  total:      { type: 'number',  required: true },
  migradas:   { type: 'number',  required: true },
  skipped:    { type: 'number',  required: true },
  bloqueadas: { type: 'number',  required: true },
  falhas:     { type: 'number',  required: true },
  por_tipo:   { type: 'object',  required: true },
  erros_zoho: { type: 'array',   required: true },
  resultados: {
    type: 'array',
    required: true,
    items: {
      zoho_id:        { type: 'string',  required: false },
      nome:           { type: 'string',  required: false },
      tipo:           { type: 'string',  required: false },
      status:         { type: 'string',  required: false },
      run_id:         { type: 'number',  required: false },
      linha_local_id: { type: 'number',  required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
      erro:           { type: 'string',  required: false },
    },
  },
})
